customElements.whenDefined('details-disclosure').then(() => {
  // Desktop only
  const MQ = window.matchMedia('(min-width: 769px)');
  if (!MQ.matches) return;

  function setupSidebarMegaNav(megaNavEl) {
    const container = megaNavEl.querySelector(':scope > .container') || megaNavEl;
    const childNav = megaNavEl.querySelector('.child-nav');
    if (!childNav) return;

    // Ensure the container is positioning context for the portal
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }

    // Create (or reuse) portal inside THIS mega nav (not <body>)
    let portal = container.querySelector('.cc-grandchild-portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.className = 'cc-grandchild-portal';
      container.appendChild(portal);
    }

    let closeTimer = null;

    function clearActive() {
      portal.classList.remove('is-open');
      portal.innerHTML = '';
      megaNavEl.querySelectorAll('.child-nav__item--toggle.is-visible').forEach((el) => {
        el.classList.remove('is-visible');
      });
    }

    function openFromSummary(summaryEl) {
      const panel = summaryEl.nextElementSibling;
      if (!panel || !panel.classList.contains('disclosure__panel')) return;

      // Mark active (keeps your left highlight styling)
      megaNavEl.querySelectorAll('.child-nav__item--toggle.is-visible').forEach((el) => {
        if (el !== summaryEl) el.classList.remove('is-visible');
      });
      summaryEl.classList.add('is-visible');

      // Clone panel INTO portal (still inside mega-nav => your CSS continues to apply)
      portal.innerHTML = '';
      const clone = panel.cloneNode(true);

      // Optional safety: avoid duplicated IDs if your panel has any (rare here)
      clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));

      portal.appendChild(clone);
      portal.classList.add('is-open');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(clearActive, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    // Hover/focus on left column opens the portal panel
    megaNavEl.querySelectorAll('summary.child-nav__item--toggle').forEach((summaryEl) => {
      summaryEl.addEventListener('mouseenter', () => openFromSummary(summaryEl));
      summaryEl.addEventListener('focusin', () => openFromSummary(summaryEl));
    });

    childNav.querySelectorAll(':scope > li > a.child-nav__item').forEach((aEl) => {
      aEl.addEventListener('mouseenter', clearActive);
      aEl.addEventListener('focusin', clearActive);
    });

    // Keep portal open when moving mouse into it
    portal.addEventListener('mouseenter', cancelClose);
    portal.addEventListener('mouseleave', scheduleClose);

    // Close when leaving the whole mega nav area
    megaNavEl.addEventListener('mouseleave', scheduleClose);
    megaNavEl.addEventListener('mouseenter', cancelClose);

    // If the mega-nav closes, clear portal
    const detailsRoot = megaNavEl.closest('details');
    if (detailsRoot) {
      detailsRoot.addEventListener('toggle', () => {
        if (!detailsRoot.open) clearActive();
      });
    }
  }

  document.querySelectorAll('.main-nav__child.mega-nav--sidebar').forEach(setupSidebarMegaNav);
});
